/* this file is auto-generated.  DO NOT MODIFY*/
import Chatbot from '../../Components/Chatbot/scripts/Chatbot.js';
import ComponentA from '../../Components/ComponentA/scripts/ComponentA.js';
import GoogleMaps from '../../Components/GoogleMaps/scripts/GoogleMaps.js';
import Headervisual from '../../Components/headervisual/scripts/headervisual.js';
import InPageNavigation from '../../Components/InPageNavigation/scripts/InPageNavigation.js';
import Tabs from '../../Components/Tabs/scripts/Tabs.js';

export default [
		Chatbot,
		ComponentA,
		GoogleMaps,
		Headervisual,
		InPageNavigation,
		Tabs
	];

